import { useThemedLayoutContext } from '@refinedev/mantine';
import { useTranslation } from '@refinedev/core';
import { IconSettings } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { Tooltip, NavLink } from '@mantine/core';

interface SettingsLinkProps {
  isCollapsed: boolean;
  mobileSiderOpen: boolean;
  selectedKey: string;
  commonNavLinkStyles: any;
  commonTooltipProps: any;
}

export const SettingsLink: React.FC<SettingsLinkProps> = ({
  isCollapsed,
  mobileSiderOpen,
  selectedKey,
  commonNavLinkStyles,
  commonTooltipProps,
}) => {
  const { setMobileSiderOpen } = useThemedLayoutContext();
  const { translate } = useTranslation();
  const label = translate('pages:settings.label');
  
  return (
    <Tooltip label={label} {...commonTooltipProps}>
      <NavLink
        key="settings"
        data-testid="settings-nav-link"
        label={isCollapsed && !mobileSiderOpen ? null : label}
        leftSection={<IconSettings size={20} />}
        to={'/settings'}
        pl={isCollapsed || mobileSiderOpen ? '0.75rem' : '1.125rem'}
        active={selectedKey === '/settings'}
        styles={commonNavLinkStyles}
        component={Link}
        onClick={() => {
          if (mobileSiderOpen) {
            setMobileSiderOpen(false);
          }
        }}
      />
    </Tooltip>
  );
};
